import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { BoxZoomIcon } from '~/assets/workspace-icons';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { selectedToolState } from '~/state/atoms/toolsAtoms';

export default function BoxZoomTool() {
    const [tool, setTool] = useRecoilState(selectedToolState);
    const intl = useIntl();

    const isSelected = tool === 'boxZoom';

    return (
        <ToolbarButton
            icon={<BoxZoomIcon />}
            tooltip={intl.formatMessage({
                id: 'toolbar.boxZoom.tooltip',
            })}
            tooltipPlacement="bottom"
            selected={isSelected}
            onClick={() => setTool(isSelected ? 'pan' : 'boxZoom')}
        />
    );
}
